module.exports = __webpack_public_path__ + "img/2023big5.9abf36f1.png";